<smrts-page primaryTitle="Dados da Conta">

  <div class="page-content">

    <div class="section">
      <h2 class="section-title">Dados da conta</h2>

      <form [formGroup]="formDados" (ngSubmit)="salvarDadosClick()" class="section-form">

        <div class="field">
          <p-floatlabel variant="on">
            <input pInputText id="login" [value]="login" disabled />
            <label for="login">Login</label>
          </p-floatlabel>
        </div>

        <div class="field">
          <p-floatlabel variant="on">
            <input pInputText id="email" type="email" formControlName="email"
              [class.ng-invalid]="isInvalidDados('email')" [class.ng-dirty]="isInvalidDados('email')" />
              <label for="email">E-mail</label>
            </p-floatlabel>
            @if (formDados.get('email')?.touched && formDados.get('email')?.hasError('required')) {
              <small class="field-error">E-mail obrigatório</small>
            }
            @if (formDados.get('email')?.touched && formDados.get('email')?.hasError('email')) {
              <small class="field-error">E-mail inválido</small>
            }
          </div>

          <div class="section-footer">
            <p-button type="submit" label="Salvar" [loading]="salvandoDados" />
          </div>

        </form>
      </div>

      <div class="section">
        <h2 class="section-title">Trocar senha</h2>

        <form [formGroup]="formSenha" (ngSubmit)="trocarSenhaClick()" class="section-form">

          <div class="field">
            <p-floatlabel variant="on">
              <input pInputText id="senhaAtual" type="password" formControlName="senhaAtual"
                [class.ng-invalid]="isInvalidSenha('senhaAtual')" [class.ng-dirty]="isInvalidSenha('senhaAtual')" />
                <label for="senhaAtual">Senha atual</label>
              </p-floatlabel>
              @if (isInvalidSenha('senhaAtual')) {
                <small class="field-error">Senha atual obrigatória</small>
              }
            </div>

            <div class="field">
              <p-floatlabel variant="on">
                <input pInputText id="novaSenha" type="password" formControlName="novaSenha"
                  [class.ng-invalid]="isInvalidSenha('novaSenha')" [class.ng-dirty]="isInvalidSenha('novaSenha')" />
                  <label for="novaSenha">Nova senha</label>
                </p-floatlabel>
                @if (formSenha.get('novaSenha')?.touched && formSenha.get('novaSenha')?.hasError('required')) {
                  <small class="field-error">Nova senha obrigatória</small>
                }
                @if (formSenha.get('novaSenha')?.touched && (formSenha.get('novaSenha')?.hasError('minlength') || formSenha.get('novaSenha')?.hasError('pattern'))) {
                  <small class="field-error">A senha deve ter no mínimo 8 caracteres, com letras e números</small>
                }
              </div>

              <div class="field">
                <p-floatlabel variant="on">
                  <input pInputText id="confirmacaoNovaSenha" type="password" formControlName="confirmacaoNovaSenha"
                    [class.ng-invalid]="isInvalidSenha('confirmacaoNovaSenha') || senhasNaoConferem"
                    [class.ng-dirty]="isInvalidSenha('confirmacaoNovaSenha') || senhasNaoConferem" />
                    <label for="confirmacaoNovaSenha">Confirmar nova senha</label>
                  </p-floatlabel>
                  @if (isInvalidSenha('confirmacaoNovaSenha')) {
                    <small class="field-error">Confirmação de senha obrigatória</small>
                  }
                  @if (senhasNaoConferem) {
                    <small class="field-error">As senhas não conferem</small>
                  }
                </div>

                @if (erroTrocarSenha) {
                  <div class="form-error">{{ erroTrocarSenha }}</div>
                }

                <div class="section-footer">
                  <p-button type="submit" label="Trocar senha" [loading]="salvandoSenha" />
                </div>

              </form>
            </div>

          </div>

        </smrts-page>
